module.exports = __webpack_public_path__ + "img/child-icon.229e3c82.svg";